import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card } from './ui/card';
import { CheckCircle2 } from 'lucide-react';

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 medical-section-bg" style={{ backgroundImage: `/images/howitworks/howitworks-2.jpg` }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
            {t.howItWorks.title}
          </h2>
          <p className="text-lg text-gray-600">
            {t.howItWorks.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Illustration */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src='/images/howitworks/howitworks-2.jpg'
                alt="How it works workflow"
                className="w-full h-auto"
                style={{ borderRadius: '24px' }}
              />
            </div>
          </div>

          {/* Right - Steps */}
          <div className="space-y-6">
            {t.howItWorks.steps.map((step, index) => (
              <Card 
                key={index}
                className="border-none shadow-md hover:shadow-lg transition-shadow bg-white"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="p-6 flex items-start space-x-4">
                  <div 
                    className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white text-xl font-bold"
                    style={{ backgroundColor: '#2D4A8F' }}
                  >
                    {index + 1}
                  </div>
                  <div className="flex-1 pt-2">
                    <p className="text-lg text-gray-800 font-medium">{step}</p>
                  </div>
                  <CheckCircle2 size={24} style={{ color: '#2D4A8F' }} className="mt-2" />
                </div>
              </Card>
            ))}

            <div className="mt-8 p-6 rounded-lg" style={{ backgroundColor: '#2D4A8F' }}>
              <p className="text-white text-center text-lg font-semibold">
                {t.howItWorks.note}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
